// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DropableImage.isDragging{border:3px solid red}`, "",{"version":3,"sources":["webpack://./resources/app/modules/common/DropableImage/index.scss"],"names":[],"mappings":"AACE,0BACE,oBAAA","sourcesContent":[".DropableImage {\n  &.isDragging {\n    border: 3px solid red;\n\n  }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
